import { render, staticRenderFns } from "./ViewControl.vue?vue&type=template&id=50c83363&scoped=true&"
import script from "./ViewControl.vue?vue&type=script&lang=ts&"
export * from "./ViewControl.vue?vue&type=script&lang=ts&"
import style0 from "./ViewControl.vue?vue&type=style&index=0&id=50c83363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c83363",
  null
  
)

export default component.exports